// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"MX2_TheComp__mdez9","ef-box":"MX2_ef-box__irWZp"};